import { css } from '@/styled-system/css';

export const scrollAlertWindowMobileStyles = css.raw({
  position: 'absolute',
  top: '500',
  left: 'calc(50% - 104px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 208px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  height: '208px',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 208px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  width: '208px',
  borderRadius: '100',
  // oxlint-disable-next-line constellation/no-raw-color-values
  backgroundColor: 'rgba(42, 42, 51, 0.9)',
});

export const buttonsContainerStyles = css.raw({
  height: 'inherit',
  minWidth: '1200',
  textAlign: 'center',
});

export const buttonsStyles = css.raw({
  position: 'relative',
  top: '1400',
  cursor: 'pointer',
});

export const homeButtonStyles = css.raw({
  position: 'relative',
  textAlign: 'center',
  cursor: 'pointer',
  top: '600',
});

export const mobileHomeButtonLeftStyles = css.raw({
  position: 'absolute',
  textAlign: 'center',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `top: -58px` falls between `-1500` (-60px) and `-1400` (-56px) on the numeric spacing scale
  top: '-58px',
  left: '600',
  cursor: 'pointer',
});

export const mobileHomeButtonRightStyles = css.raw({
  position: 'absolute',
  textAlign: 'center',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `top: -58px` falls between `-1500` (-60px) and `-1400` (-56px) on the numeric spacing scale
  top: '-58px',
  right: '600',
  cursor: 'pointer',
});
